import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[pmPasswordPattern]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: PasswordPatternDirective,
      multi: true
    }
  ]
})
export class PasswordPatternDirective implements Validator {
  private regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value || this.regex.test(value)) {
      return null; // Valid or empty
    } else {
      return { passwordPattern: true }; // Invalid pattern
    }
  }
}
